// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import cloneDeep from 'lodash/cloneDeep';
import QUICK_VIEW_CONSTANT from './QuickViewModal.constants';
import { DEFAULT_REDUCER_KEY } from '../../../../../utils/cache.util';

const initialState = fromJS({
  isLoading: false,
  [DEFAULT_REDUCER_KEY]: null,
});

function quickViewReducerBreak(state, action) {
  switch (action.type) {
    case QUICK_VIEW_CONSTANT.SINGLE_TAB_STORE:
      return state
        .set('singlepageload', action.payload.singlepageload)
        .set(
          'availableTCPMultipackProductMapping',
          action.payload.availableTCPMultipackProductMapping
        )
        .set('initialSelectedQty', action.payload.initialSelectedQty)
        .set(
          'availableTCPMultipackProductMappingQuickView',
          action.payload.availableTCPMultipackProductMapping
        )
        .set('availableTCPmapNewStyleId', action.payload.availableTCPmapNewStyleId)
        .set(
          'availableColorConsolidationTCPmapNewStyleId',
          action?.payload?.availableColorConsolidationTCPmapNewStyleId || []
        );
    case QUICK_VIEW_CONSTANT.QUICK_SINGLE_TAB_STORE:
      return state.set('initalQuickViewLoad', action.payload.initalQuickViewLoad);

    case QUICK_VIEW_CONSTANT.SET_DISABLE_SELECTED_TAB:
      return state.set('disabledTab', action.payload.disabledTab);
    case QUICK_VIEW_CONSTANT.SET_SELECTED_PRODUCT_DATA:
      return state
        .set('pageTitle', action.payload.pageTitle)
        .set('productImage', action.payload.productImage)
        .set('plpItemData', action.payload.plpItemData);
    case QUICK_VIEW_CONSTANT.SHOW_RATING_VIEW:
      return state.set('showRatingView', action.payload.showRatingView);
    default:
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
}

// eslint-disable-next-line complexity
const QuickViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case QUICK_VIEW_CONSTANT.SET_QUICK_VIEW:
      return state.set('quickViewProducts', action.payload);

    case QUICK_VIEW_CONSTANT.SET_MULTIPRODUCT_DETAILS:
      return state.set('newPartNumber', action.payload);

    case QUICK_VIEW_CONSTANT.SET_ITEM_FROM_BAG_INFO:
      return state
        .set('fromBagPage', action.payload.fromBagPage)
        .set('isSflProduct', action.payload.isSflProduct)
        .set('quickViewProductFromBag', action.payload.orderInfo)
        .set('isFavoriteEdit', action.payload.isFavoriteEdit)
        .set('pdpUrl', action.payload.pdpUrl)
        .set('uniqueId', action.payload.uniqueId)
        .set('fromPage', action.payload.fromPage)
        .set('sbpNavigation', action.payload.sbpNavigation)
        .set('isSBP', action.payload.isSBP)
        .set('fromAccessory', action.payload.fromAccessory)
        .set('dimension66', action.payload.dimension66)
        .set('isFromStoreModal', action.payload.isFromStoreModal)
        .set('dimension81', action.payload.dimension81)
        .set('isTopRated', action.payload.isTopRatedProduct)
        .set('isBestSeller', action.payload.isBestSellerProduct)
        .set('isOutfitsOnBag', action.payload.isOutfitsOnBag);
    case QUICK_VIEW_CONSTANT.SET_PRODUCT_QV_ID:
      return state.set('uniqueId', action.payload);
    case QUICK_VIEW_CONSTANT.SET_LOADING_STATE:
      return state.set('isLoading', action.payload.isLoading);
    case QUICK_VIEW_CONSTANT.SET_LOADING_ERROR:
      return state.set('isLoadingError', action.payload.loadingError);
    case QUICK_VIEW_CONSTANT.SET_EVAR_152:
      return state.set('eVar152', action.payload.eVar152);
    case QUICK_VIEW_CONSTANT.SET_MODULEX_CONTENT:
      return state.set('quickViewPromo', action.payload.richText);
    case QUICK_VIEW_CONSTANT.OPEN_QUICK_VIEW_MODAL:
      return state.set('isModalOpen', action.payload.isModalOpen).set('keepMinibagClose', true);
    case QUICK_VIEW_CONSTANT.UPDATE_MINIBAG_CLOSE_STATUS:
      return state.set('keepMinibagClose', action.payload);
    case QUICK_VIEW_CONSTANT.SET_QUICK_VIEW_PRODUCT_TITLE:
      return state.set('pageTitle', action.payload);
    case QUICK_VIEW_CONSTANT.SET_QUICK_VIEW_PRODUCT_IMAGE:
      return state.set('productImage', action.payload);
    case QUICK_VIEW_CONSTANT.SET_BRAND_NAME:
      return state.set('brandName', action.payload);
    case QUICK_VIEW_CONSTANT.SET_TOTAL_PRICES:
      return state.set('totalPrices', action.payload);
    case QUICK_VIEW_CONSTANT.FETCH_QUICK_VIEW:
      return state
        .set('isFavoritePage', action.payload?.isFavoritePage)
        .set('isFromBirthdayModule', action?.payload?.fromBirthdayModule)
        .set('fromPageBranch', action?.payload?.fromPageBranch);
    case QUICK_VIEW_CONSTANT.PREVIOUS_SCREEN:
      return state.set('previousScreen', action.payload.previousScreen);
    case QUICK_VIEW_CONSTANT.PREVIOUS_SCREEN_ID:
      return state.set('previousScreenID', action.payload.previousScreenID);
    case QUICK_VIEW_CONSTANT.CLOSE_QUICK_VIEW_MODAL:
      return state
        .set('fromBagPage', false)
        .set('isSflProduct', false)
        .set('isModalOpen', action.payload.isModalOpen)
        .set('quickViewProducts', null)
        .set('newPartNumber', { multiPackData: null })
        .set('quickViewProductFromBag', null)
        .set('isFavoriteEdit', false)
        .set('fromPage', null)
        .set('fromAccessory', null)
        .set('pageTitle', null)
        .set('productImage', null)
        .set('plpItemData', null)
        .set('isOutfitsOnBag', false);
    case QUICK_VIEW_CONSTANT.SAVE_DATA_FOR_PDP:
      return state.set('pdpProductData', action.payload);
    case QUICK_VIEW_CONSTANT.SET_PLP_DATA_FOR_QUICKVIEW:
      return state.set('plpProductData', action.payload);
    case QUICK_VIEW_CONSTANT.SET_SLP_DATA_FOR_QUICKVIEW:
      return state.set('slpProductData', action.payload);
    case QUICK_VIEW_CONSTANT.SET_ITEM_DATA_FOR_QUICKVIEW:
      return state.set('plpItemData', action.payload);
    case QUICK_VIEW_CONSTANT.RESET_BIRTHDAY_MODULE_VALUE:
      return state.set('isFromBirthdayModule', action.payload);
    case QUICK_VIEW_CONSTANT.RESET_QUICK_VIEW_PRODUCT:
      return state.set('quickViewProducts', null);
    case QUICK_VIEW_CONSTANT.RESET_PDP_QUICK_VIEW_PRODUCT:
      return state.set('pdpProductData', null);
    case QUICK_VIEW_CONSTANT.RESET_MULTIPACK_PRODUCT:
      return state.set('newPartNumber', { multiPackData: null });
    case QUICK_VIEW_CONSTANT.UPDATE_DATA_ON_NEW_FITS_CLICK: {
      const { index, data } = action.payload;
      return state.update('quickViewProducts', (quickViewProducts) => {
        const tmp = cloneDeep(quickViewProducts);
        if (tmp[index]) {
          tmp[index] = data;
        }
        return tmp;
      });
    }
    default:
      return quickViewReducerBreak(state, action);
  }
};

export default QuickViewReducer;
